import { useState, useEffect } from 'react'
import { FormGroup, Panel, Icon, ControlLabel, Message, InputPicker } from 'rsuite'
import { Grid, Row, Col } from 'rsuite'
import { Form, Radio, RadioGroup, DatePicker } from 'rsuite'
import { isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import moment from 'moment'
import NumberFormat from 'react-number-format'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH, REQUEST_DATE_FORMAT } from '../../../constants/date'
import {
  searchProjectBySearchKeyPaging,
  searchProjectPaging,
} from '../../../redux/actions/projectType'

export default function ProjectTypeGroup({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  projectId,
}) {
  const notRequired = { required: false }
  const [projectCodeRequired, setProjectCodeRequired] = useState()
  const [subProjectRequired, setSubProjectRequired] = useState()
  const [actualPeriod, setOperationPeriodType] = useState(
    schema?.workingTime?.maxEndDate ? 1 : schema.workingTime.actualPeriod.value || '1'
  )
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [projectList, setProjectList] = useState([])
  const [projectSelected, setProjectSelected] = useState()
  const [isSearchSubProject, setIsSearchSubProject] = useState(false)
  const [offerFundedInfo, setOfferFundedInfo] = useState()

  useEffect(() => {
    if (schema) {
      onChangeProjectType(schema.projectType.value)
      onChangeSubProject(schema.projectType.subProject.value)

      setValue(schema.projectType.subProject.name, schema.projectType.subProject.value)
      setValue(
        schema.projectType.subProject.projectCode.name,
        schema.projectType.subProject.projectCode.value
      )

      setOperationPeriodType(
        schema?.workingTime?.maxEndDate ? 1 : schema.workingTime.actualPeriod.value || '1'
      )

      if (
        schema?.projectType?.subProject?.value === 1 &&
        schema?.projectType?.subProject?.projectCode?.value
      ) {
        handleSearchProjectByCode(schema.projectType.subProject.projectCode.value)
      }

      setOfferFundedInfo(
        schema?.offerFundedInfo?.docList?.filter((e) => e.type == schema?.offerFunded?.value)?.[0]
      )
    }
  }, [schema])

  const handleSearchProjectByName = async (searchKey) => {
    //startLoading()
    setIsSearchSubProject(true)
    setIsError(false)
    try {
      const response = await searchProjectBySearchKeyPaging(projectId, 50, 1, searchKey, '')
      // console.log('response', response)
      const searchResults = response.searchResults.map((item) => {
        return { ...item, label: `${item.projectCode} : ${item.projectName}` }
      })
      setProjectList(searchResults || [])
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsSearchSubProject(false)
    //doneLoading()
  }

  const handleSearchProjectByCode = async (projectCode) => {
    //startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await searchProjectPaging(projectId, 50, 1, projectCode, '', '')
      // console.log('response', response)

      const searchResults = response.searchResults.map((item) => {
        return { ...item, label: `${item.projectCode} : ${item.projectName}` }
      })

      setProjectList(searchResults || [])

      if (searchResults.length === 1) {
        setProjectSelected(searchResults[0])
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    //doneLoading()
  }

  const onChangeProjectFeature = (value) => {
    setValue(schema.projectFeature.name, value)
    clearErrors(schema.projectFeature.name)
  }

  const onChangeProjectType = (value) => {
    setValue(schema.projectType.name, value)
    clearErrors(schema.projectType.name)
    //if (value != '1') {
    // setSubProjectRequired(notRequired)
    // setProjectCodeRequired(notRequired)
    // setValue(schema.projectType.subProject.name, '')
    // setValue(schema.projectType.subProject.projectCode.name, '')
    // clearErrors(schema.projectType.subProject.name)
    // clearErrors(schema.projectType.subProject.projectCode.name)
    //} else {
    setSubProjectRequired({ required: 'กรุณาเลือกประเภทโครงการ' })
    //}
  }

  const onChangeSubProject = (value) => {
    setValue(schema.projectType.subProject.name, value)
    clearErrors(schema.projectType.subProject.name)
    if (value != '1') {
      setProjectCodeRequired(notRequired)
      setValue(schema.projectType.subProject.projectCode.name, '')
      clearErrors(schema.projectType.subProject.projectCode.name)
    } else {
      setProjectCodeRequired({ required: 'กรุณาระบุชื่อหรือรหัสโครงการต่อเนื่อง' })
    }
  }

  const onChangeOfferFunded = (value) => {
    setValue(schema.offerFunded.name, value)
    clearErrors(schema.offerFunded.name)

    setOfferFundedInfo(schema?.offerFundedInfo?.docList?.filter((e) => e.type == value)?.[0])
  }

  const handleSearch = (value) => {
    if (!value) {
      return
    }
    handleSearchProjectByName(value)
  }

  const onSelectSubProject = (value) => {
    setProjectSelected(value)
    setValue(schema.projectType.subProject.projectCode.name, value)
    clearErrors(schema.projectType.subProject.projectCode.name)
  }

  const onCleanSubProject = () => {
    setProjectSelected()
    setValue(schema.projectType.subProject.projectCode.name)
  }

  const projectFeaturePanel = () => {
    return (
      <Panel header={requiredFiled(schema.projectFeature.validators, schema.projectFeature.label)}>
        <Grid fluid style={panelDetailMargin}>
          <ErrorMessage error={errors[schema.projectFeature.name]} />

          <Controller
            key={schema.projectFeature.name}
            name={schema.projectFeature.name}
            control={control}
            rules={isValidators(schema.projectFeature.validators)}
            defaultValue={schema.projectFeature.value}
            render={(props) => {
              return (
                <RadioGroup inline value={props.value} onChange={onChangeProjectFeature}>
                  {schema.projectFeature.options.map((item, index) => {
                    return (
                      <Radio
                        key={index}
                        disabled={schema.projectFeature.disabled}
                        name={item.name}
                        value={item.value}
                      >
                        {item.label}
                      </Radio>
                    )
                  })}
                </RadioGroup>
              )
            }}
          ></Controller>
        </Grid>
      </Panel>
    )
  }

  const projectTypePanel = () => {
    return (
      <Panel
        header={requiredFiled(schema.projectType.validators, schema.projectType.label)}
        style={{ marginTop: -20 }}
      >
        <Grid fluid style={panelDetailMargin}>
          <ErrorMessage error={errors[schema.projectType.name]} />

          <Controller
            key={schema.projectType.name}
            name={schema.projectType.name}
            control={control}
            rules={isValidators(schema.projectType.validators)}
            defaultValue={schema.projectType.value}
            render={(props) => {
              return (
                <RadioGroup inline value={props.value} onChange={onChangeProjectType}>
                  <Radio
                    value={schema.projectType.project.value}
                    disabled={schema.projectType.project.disabled}
                  >
                    {schema.projectType.project.label}
                  </Radio>
                  <Radio
                    value={schema.projectType.projectKit.value}
                    disabled={schema.projectType.project.disabled}
                  >
                    {schema.projectType.projectKit.label}
                  </Radio>
                  <Radio
                    value={schema.projectType.projectPlan.value}
                    disabled={schema.projectType.project.disabled}
                  >
                    {schema.projectType.projectPlan.label}
                  </Radio>
                </RadioGroup>
              )
            }}
          />

          {subProjectRadio()}
        </Grid>
      </Panel>
    )
  }

  const subProjectRadio = () => {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ErrorMessage error={errors[schema.projectType.subProject.name]} />
          <ErrorMessage error={errors[schema.projectType.subProject.projectCode.name]} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xsOffset={1} smOffset={1} mdOffset={1}>
          <Controller
            key={schema.projectType.subProject.name}
            name={schema.projectType.subProject.name}
            control={control}
            rules={subProjectRequired}
            defaultValue={getValues(schema.projectType.subProject.name)}
            render={(props) => {
              return (
                <RadioGroup
                  inline
                  value={props.value}
                  onChange={onChangeSubProject}
                  style={{ width: '100%' }}
                >
                  <Row>
                    <Col xs={24} sm={24} md={10} lg={10} style={{ width: 'auto' }}>
                      <Radio
                        value={schema.projectType.subProject.newProject.value}
                        disabled={
                          getValues(schema.projectType.name) == '' ||
                          schema.projectType.subProject.newProject.disabled
                        }
                      >
                        {schema.projectType.subProject.newProject.label}
                      </Radio>
                      <Radio
                        value={schema.projectType.subProject.ongoingProject.value}
                        disabled={
                          getValues(schema.projectType.name) == '' ||
                          schema.projectType.subProject.newProject.disabled
                        }
                      >
                        {schema.projectType.subProject.ongoingProject.label}
                      </Radio>
                    </Col>
                    <Col xs={24} sm={24} md={14} lg={14}>
                      <Controller
                        key={schema.projectType.subProject.projectCode.name}
                        name={schema.projectType.subProject.projectCode.name}
                        control={control}
                        rules={projectCodeRequired}
                        defaultValue={getValues(schema.projectType.subProject.projectCode.name)}
                        render={(props) => {
                          return (
                            <InputPicker
                              style={{ width: '100%', paddingBottom: 2 }}
                              placeholder={
                                schema.projectType.subProject.projectCode.label
                                // 'ระบุชื่อ หรือรหัสของโครงการ/ชุดโครงการ/แผนงาน'
                              }
                              value={props.value}
                              //name={schema.projectType.subProject.projectCode.name}
                              data={projectList}
                              labelKey="label"
                              valueKey="projectCode"
                              onSearch={handleSearch}
                              onSelect={onSelectSubProject}
                              onClean={onCleanSubProject}
                              disabled={
                                getValues(schema.projectType.subProject.name) != '1' ||
                                schema.projectType.subProject.projectCode.disabled
                              }
                              renderMenu={(menu) => {
                                if (isSearchSubProject) {
                                  return (
                                    <p style={{ padding: 4, color: '#999', textAlign: 'center' }}>
                                      <Icon icon="spinner" spin /> Loading...
                                    </p>
                                  )
                                }
                                return menu
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                </RadioGroup>
              )
            }}
          ></Controller>
        </Col>

        {/* <Col xs={22} sm={22} md={8} lg={8} xsOffset={2} smOffset={2} mdOffset={1}>
          <Controller
            key={schema.projectType.subProject.name}
            name={schema.projectType.subProject.name}
            control={control}
            rules={subProjectRequired}
            defaultValue={getValues(schema.projectType.subProject.name)}
            render={(props) => {
              return (
                <RadioGroup inline value={props.value} onChange={onChangeSubProject}>
                   <Radio
                    value={schema.projectType.subProject.newProject.value}
                    disabled={
                      getValues(schema.projectType.name) != '1' ||
                      schema.projectType.subProject.newProject.disabled
                    }
                  >
                    {schema.projectType.subProject.newProject.label}
                  </Radio> 
                  <Radio
                    value={schema.projectType.subProject.ongoingProject.value}
                    disabled={
                      getValues(schema.projectType.name) != '1' ||
                      schema.projectType.subProject.newProject.disabled
                    }
                  >
                    {schema.projectType.subProject.ongoingProject.label}
                  </Radio>
                </RadioGroup>
              )
            }}
          ></Controller>
        </Col> */}
        {/* <Col xs={21} sm={21} md={8} lg={8} xsOffset={3} smOffset={3} mdOffset={0}>
          <InputGroup
            style={{ width: '100%' }}
            disabled={
              getValues(schema.projectType.subProject.name) != '1' ||
              schema.projectType.subProject.projectCode.disabled
            }
          >
            <Input
              placeholder={schema.projectType.subProject.projectCode.label}
              defaultValue={getValues(schema.projectType.subProject.projectCode.name)}
              name={schema.projectType.subProject.projectCode.name}
              inputRef={register(projectCodeRequired)}
            />
            <InputGroup.Addon>
              <Icon icon="search" />
            </InputGroup.Addon>
          </InputGroup>
        </Col> */}
      </Row>
    )
  }

  const offerFundedPanel = () => {
    return (
      <Panel
        header={requiredFiled(schema.offerFunded.validators, schema.offerFunded.label)}
        style={{ marginTop: -20 }}
      >
        <Grid fluid style={panelDetailMargin}>
          <ErrorMessage error={errors[schema.offerFunded.name]} />

          <Controller
            key={schema.offerFunded.name}
            name={schema.offerFunded.name}
            control={control}
            rules={isValidators(schema.offerFunded.validators)}
            defaultValue={schema.offerFunded.value}
            render={(props) => {
              return (
                <RadioGroup
                  inline
                  disabled={schema.offerFunded.disabled}
                  value={props.value}
                  onChange={onChangeOfferFunded}
                >
                  {schema.offerFunded.options.map((item, index) => {
                    return (
                      <Radio key={index} name={item.name} value={item.value}>
                        {item.label}
                      </Radio>
                    )
                  })}
                </RadioGroup>
              )
            }}
          />
          {/* ซ่อน info  */}
          {/* {offerFundedInfo && (
            <Message
              type="info"
              showIcon
              style={{ marginTop: 5 }}
              description={
                <>
                  <strong>{schema.offerFundedInfo.header}</strong>
                  <ul style={{ marginTop: 10 }}>
                    {offerFundedInfo?.list?.map((item) => {
                      return <li>{item}</li>
                    })}
                  </ul>
                </>
              }
            />
          )} */}
        </Grid>
      </Panel>
    )
  }

  const workingTimePanel = () => {
    return (
      <Panel
        header={requiredFiled(schema.workingTime.validators, schema.workingTime.label)}
        style={{ marginTop: -20 }}
      >
        <Row style={panelDetailMargin}>
          {schema.workingTime.actualPeriod?.options ? (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 10 }}>
              <Controller
                key={schema.workingTime.actualPeriod.name}
                name={schema.workingTime.actualPeriod.name}
                control={control}
                rules={isValidators(schema.workingTime.actualPeriod.validators)}
                defaultValue={actualPeriod}
                render={(props) => {
                  return (
                    <RadioGroup
                      key={schema.workingTime.actualPeriod.name + '_redio'}
                      value={props.value}
                      inline
                      onChange={(value) => {
                        props.onChange(value)
                        setOperationPeriodType(value)
                      }}
                    >
                      {schema.workingTime.actualPeriod?.options?.map((item) => {
                        return <Radio value={item.value}>{item.label}</Radio>
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </Col>
          ) : (
            <Message showIcon type="warning" description={schema?.workingTime?.alertMessage} />
          )}
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={schema.workingTime.projectReportDay ? 6 : 8}
            style={{ width: 260 }}
          >
            <ErrorMessage error={errors[schema.workingTime.startDate.name]} />
            <ControlLabel>
              {' '}
              {requiredFiled(
                schema.workingTime.startDate.validators,
                schema.workingTime.startDate.label
              )}
            </ControlLabel>

            <Controller
              key={schema.workingTime.startDate.name}
              name={schema.workingTime.startDate.name}
              control={control}
              rules={isValidators(schema.workingTime.startDate.validators)}
              defaultValue={
                schema.workingTime.startDate.value
                  ? moment(schema.workingTime.startDate.value, REQUEST_DATE_FORMAT).toDate()
                  : null
              }
              render={(props) => {
                return (
                  // <IntlProvider formatDate={formatDate}>
                  <DatePicker
                    format={DATE_PICKER_FORMAT}
                    locale={LOCAL_DAY_TH}
                    block
                    appearance="subtle"
                    placement="auto"
                    disabled={
                      schema.workingTime.startDate.disabled || schema?.workingTime?.alertMessage
                    }
                    disabledDate={(date) => {
                      let currentStart = schema.workingTime.startDate.value
                        ? moment(schema.workingTime.startDate.value, REQUEST_DATE_FORMAT).toDate()
                        : null

                      let endDate = getValues(schema.workingTime.endDate.name)
                      let startDate =
                        currentStart && moment(currentStart).isBefore(new Date())
                          ? currentStart
                          : moment(new Date()).add(-1, 'days').toDate()

                      return (
                        moment(startDate).isAfter(date, new Date()) ||
                        (endDate && moment(endDate).isBefore(date, new Date()))
                      )
                    }}
                    value={props.value}
                    onChange={(value) => {
                      setValue(schema.workingTime.startDate.name, value)
                      clearErrors(schema.workingTime.startDate.name)
                    }}
                    onClean={() => {
                      setValue(schema.workingTime.startDate.name)
                    }}
                  />
                  // </IntlProvider>
                )
              }}
            />
          </Col>
          {actualPeriod == 1 && (
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={schema.workingTime.projectReportDay ? 6 : 8}
              style={{ width: 260 }}
            >
              <ErrorMessage error={errors[schema.workingTime.endDate.name]} />
              <ControlLabel>
                {requiredFiled(
                  schema.workingTime.endDate.validators,
                  schema.workingTime.endDate.label
                )}
              </ControlLabel>
              <Controller
                key={schema.workingTime.endDate.name}
                name={schema.workingTime.endDate.name}
                control={control}
                rules={isValidators(schema.workingTime.endDate.validators)}
                defaultValue={
                  schema.workingTime.endDate.value
                    ? moment(schema.workingTime.endDate.value, REQUEST_DATE_FORMAT).toDate()
                    : null
                }
                render={(props) => {
                  return (
                    <DatePicker
                      format={DATE_PICKER_FORMAT}
                      locale={LOCAL_DAY_TH}
                      block
                      appearance="subtle"
                      placement="auto"
                      disabled={schema.workingTime.endDate.disabled}
                      disabledDate={(date) => {
                        let currentStart = schema.workingTime.startDate.value
                          ? moment(schema.workingTime.startDate.value, REQUEST_DATE_FORMAT).toDate()
                          : null

                        let startDate = getValues(schema.workingTime.startDate.name)

                        startDate =
                          startDate ||
                          (currentStart && moment(currentStart).isBefore(new Date())
                            ? currentStart
                            : moment(new Date()).add(-1, 'days').toDate())

                        return (
                          (startDate && moment(startDate).isAfter(date, new Date())) ||
                          (schema.workingTime.maxEndDate &&
                            moment(schema.workingTime.maxEndDate).isBefore(date, new Date()))
                        )
                      }}
                      name={schema.workingTime.endDate.name}
                      value={props.value}
                      onChange={(value) => {
                        setValue(schema.workingTime.endDate.name, value)
                        clearErrors(schema.workingTime.endDate.name)
                      }}
                      onClean={() => {
                        setValue(schema.workingTime.endDate.name)
                      }}
                    />
                  )
                }}
              />
            </Col>
          )}

          {actualPeriod == 2 && (
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={schema.workingTime.projectReportDay ? 6 : 8}
              style={{ width: 150 }}
            >
              <ErrorMessage error={errors[schema.workingTime.monthCount.name]} />
              <ControlLabel>
                {requiredFiled(
                  schema.workingTime.monthCount.validators,
                  schema.workingTime.monthCount.label
                )}
              </ControlLabel>
              <Controller
                key={schema.workingTime.monthCount.name}
                name={schema.workingTime.monthCount.name}
                control={control}
                rules={isValidators(schema.workingTime.monthCount.validators)}
                defaultValue={schema.workingTime.monthCount.value}
                render={(props) => {
                  return (
                    <NumberFormat
                      className="rs-input"
                      disabled={schema.workingTime.monthCount.disabled}
                      placeholder={schema.workingTime.monthCount.hint}
                      thousandSeparator={true}
                      value={props.value}
                      onValueChange={(value) => {
                        props.onChange(value.floatValue)
                      }}
                    />
                  )
                }}
              />
            </Col>
          )}

          {schema.workingTime.projectReportDay && (
            <Col xs={24} sm={12} md={8} lg={6} style={{ width: 230 }}>
              <ErrorMessage error={errors[schema.workingTime.projectReportDay.name]} />
              <ControlLabel>
                {requiredFiled(
                  schema.workingTime.projectReportDay.validators,
                  schema.workingTime.projectReportDay.label
                )}
              </ControlLabel>
              <Controller
                key={schema.workingTime.projectReportDay.name}
                name={schema.workingTime.projectReportDay.name}
                control={control}
                rules={isValidators(schema.workingTime.projectReportDay.validators)}
                defaultValue={schema.workingTime.projectReportDay.value}
                render={(props) => {
                  return (
                    <NumberFormat
                      className="rs-input"
                      disabled={schema.workingTime.projectReportDay.disabled}
                      placeholder={
                        schema.workingTime.projectReportDay.hint ||
                        `ระบุ${schema.workingTime.projectReportDay.label}`
                      }
                      thousandSeparator={true}
                      value={props.value}
                      onValueChange={(value) => {
                        props.onChange(value.floatValue)
                      }}
                    />
                  )
                }}
              />
            </Col>
          )}
        </Row>
      </Panel>
    )
  }

  return (
    <div>
      <Form>
        <Panel collapsible defaultExpanded bodyFill>
          <Grid fluid style={panelDetailMargin}>
            <FormGroup controlId="projecttypegroup">
              {projectFeaturePanel()}
              {projectTypePanel()}
              {offerFundedPanel()}
              {workingTimePanel()}
            </FormGroup>
          </Grid>
        </Panel>
      </Form>
    </div>
  )
}

const panelDetailMargin = { marginTop: -20 }
